module.exports = __webpack_public_path__ + "img/box_white.fd095b97.svg";